var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.$t('langs')),function(lang){return _c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setLang(lang.code)}}},[_c('span',[_vm._v(_vm._s(lang.name))])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }